import { TripTypes } from '@model/common';
import { Name } from '@model/iceberg';
import { FooterTypes, PageTemplates, TemplateData } from '@model/content';
import { AppVariant } from '@model/config/brands';
import { NavBarContainer } from '@components/navigation';
import { ComponentsContainer } from '@components/content';
import { PromoBannerContainer } from '@components/content/common';
import SearchTabsBar from '@components/search/SearchTabsBar';
import { Footer } from '@components/footer';

interface GenericPageLayoutProps extends TemplateData {
  componentsData?: Array<any>;
  tripType?: TripTypes;
  path?: string;
  type?: PageTemplates;
  destination?: Name;
  footerType?: FooterTypes;
  promoBannerTripType?: TripTypes;
}

export const GenericPageLayout = ({
  components,
  componentsData,
  footerType,
  path,
  tripType,
  type,
  destination,
  promoBannerTripType
}: GenericPageLayoutProps) => {
  const isWhiteLabel = AppVariant.isWhitelabel();

  return (
    <>
      <NavBarContainer renderSearch={<SearchTabsBar condensed />} />
      {!isWhiteLabel && promoBannerTripType && <PromoBannerContainer promoBannerTripType={promoBannerTripType} />}
      <ComponentsContainer
        components={components}
        componentsData={componentsData}
        path={path}
        tripType={tripType}
        destination={destination}
        type={type}
        isWhiteLabel={isWhiteLabel}
      />
      <Footer type={footerType} hideReviews />
    </>
  );
};
